import { useMutation, useQueryClient } from '@tanstack/react-query';

import { type StudioBranding } from '~entities/studios/api/get-wait-list-status';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

/** Empty string/null clears an override (reset that field to Enrollio default). */
export type StudioBrandingUpdate = {
  [K in keyof StudioBranding]?: string | null;
};

interface UpdateWaitListStatusParams {
  waitlistEnabled?: boolean;
  trialBookingEnabled?: boolean;
  hideSpotsRemaining?: boolean;
  classPaymentDetails?: boolean;
  autoFilterClassesByStudentAge?: boolean;
  allowParentScheduledDrop?: boolean;
  absenceNotificationsEnabled?: boolean;
  ghlEmailSyncEnabled?: boolean;
  lessonReminders?: {
    daysBefore?: 1 | 2 | 3;
    recipients?: 'parent' | 'teacher' | 'both';
    privateLessonsEnabled?: boolean;
  };
  membershipFeeReminders?: {
    enabled?: boolean;
    returningAmount?: number;
    newAmount?: number;
  };
  /** ENR-3484: save via PUT /studios/feature-settings (not logo PATCH). */
  branding?: StudioBrandingUpdate;
}

export const updateWaitListStatus = async (
  params: UpdateWaitListStatusParams,
) => {
  const response = await baseAPI.put<unknown>(
    '/studios/feature-settings',
    params,
  );
  return response.data;
};

export const useUpdateWaitListStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateWaitListStatus,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: [KEYS.WAIT_LIST_STATUS] });
    },
    // onError: (error: any) => {},
  });
};
